import { makeStyles } from '@rbx/ui';

const useIteratorStyles = makeStyles()(() => ({
  deprecationMessage: {
    marginBottom: 24,
  },
}));

export default useIteratorStyles;
